import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import BatchLookupTable from "./-batch-lookup-table";
import WarehouseProductDetails from "./-product-details";
import { getGetOwnedStockDetailsQueryOptions } from "@/requests/gen/react-query/owned-stock";
import { OwnedStockCrumbs } from "../-crumbs";
import numericId from "@/lib/numeric-id";

export const Route = createFileRoute(
  "/_private/_stock-360/owned-stock/$catalogProductId/",
)({
  loader: ({ context: { queryClient }, params: { catalogProductId } }) =>
    queryClient.ensureQueryData(
      getGetOwnedStockDetailsQueryOptions(numericId(catalogProductId)),
    ),
  component: OwnedStockDetailsPage,
});

function OwnedStockDetailsPage() {
  const { catalogProductId } = Route.useParams();
  const catalogProductIdInt = numericId(catalogProductId);
  const { data: warehouse } = useSuspenseQuery(
    suspenseOptions(getGetOwnedStockDetailsQueryOptions(catalogProductIdInt)),
  );

  return (
    <div>
      <title>
        {`Owned ${warehouse?.catalog_product.product_base.name} - Legrande Health Portal`}
      </title>
      <OwnedStockCrumbs />
      <div className="flex flex-col w-full gap-4">
        {warehouse && (
          <>
            <WarehouseProductDetails warehouse={warehouse} />

            {/* Only show the batch table if we have a linked warehouse_vendor */}
            <div className="col-span-full">
              {warehouse.warehouse_vendors.length > 0 && (
                <BatchLookupTable
                  rows={warehouse.warehouse_vendors.flatMap((warehouseVendor) =>
                    warehouseVendor.batches.map((batch) => ({
                      batch: batch,
                      vendor:
                        warehouse.source === "Manufactured"
                          ? "Manufactured"
                          : warehouseVendor.vendor?.name || "",
                    })),
                  )}
                />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
